<div class="container-fluid">
  <h3 *ngIf="!isEdit">Creación de Rol</h3>
  <h3 *ngIf="isEdit">Edición de Rol</h3>
  <h4>habilita los módulos que desees asignar seleccionando el símbolo de “check” en los módulos correspondientes.</h4>

  <form name="roleForm" [formGroup]="roleForm" novalidate>
    <div class="row mt-5">
        <div class="col-md-6">
          <div class="form-group">
            <label for="roleName">Nombre del Rol</label>
            <input formControlName="roleName" type="text" class="form-control" id="roleName" name="roleName">
            <span class="text-danger"
                  *ngIf="roleForm.get('roleName').hasError('required')">
              <strong>Nombre de rol es requerido</strong>
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="roleDescription">Descripción del Rol</label>
            <input type="text" class="form-control" formControlName="roleDescription" id="roleDescription" name="roleDescription">
            <span class="text-danger"
                  *ngIf="roleForm.get('roleDescription').hasError('required')">
              <strong>Descripción de rol es requerido</strong>
            </span>
          </div>
        </div>
    </div>
    <div>
    </div>
    <div class="row">
      <div class="col-md-6" *ngFor="let item of data">
        <div class="permisos">
          <div class="row title">
            <div class="col-2">
              <span class="vertical-center">
                <img height="30" src="../../../assets/icons/arrow-up-circle.png">
              </span>
            </div>
            <div class="col-7">
              <h1 class="vertical-center">{{ item.moduleName }} </h1>
            </div>
            <div class="col-3">
            </div>
          </div>
          <div *ngIf="!isEdit" class="row subtitle">
            <div class="col-9">
              <h1 class="vertical-center">ACTIVAR / DESACTIVAR TODOS</h1>
            </div>
            <div class="col-3">
              <div class="round">
                <input
                  type="checkbox"
                  class="round-input" id="checkbox"
                  [checked]="item.filterAll"
                  (change)="selectAllPermissions($event.target.checked, item.moduleId)"
                  [disabled]="item.permissions.length === 0">
                <label for="checkbox" class="round-label"></label>
              </div>
            </div>
          </div>
          <div class="row rowitem" *ngFor="let permission of item.permissions">
            <div class="col-9">
              <h1 class="vertical-center" *ngIf="permission.permissionName=='SEGURIDAD'||permission.permissionName=='EVALUACION WEB'||permission.permissionName=='INICIATIVA MASIVA'||permission.permissionName=='REPORTERIA'||permission.permissionName=='EVALUACION APP'"><strong>{{ permission.permissionName.toUpperCase()}}*</strong></h1>
              <h1 class="vertical-center"*ngIf="permission.permissionName!='SEGURIDAD'&& permission.permissionName!='EVALUACION WEB'&& permission.permissionName!='INICIATIVA MASIVA'&& permission.permissionName!='REPORTERIA'&& permission.permissionName!='EVALUACION APP'">{{ permission.permissionName.toUpperCase() }}</h1>
            </div>
            <div class="col-3">
              <div class="round" *ngIf="!isEdit">
                <input
                  type="checkbox"
                  [checked]="permission.checked"
                  (change)="permission.checked = !permission.checked; verifyAllChecked(item.moduleId)"
                  class="round-input"
                  id="permissionCheckCreate">
                <label for="permissionCheckCreate" class="round-label"></label>
              </div>
              <div class="round" *ngIf="isEdit">
                <input
                  type="checkbox"
                  [checked]="permission.checked"
                  (change)="updateRolePermission(permission.rolePermissionId, !permission.checked);"
                  class="round-input"
                  id="permissionCheckEdit">
                <label for="permissionCheckEdit" class="round-label"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 20px;">
    <div class="col-md-3">
      <div style="text-align: left;">
        <button
          [routerLink]="['/modulo-seguridad/', 'seguridad', 'listado-roles']"
          class="btn round-button-back"
          (click)="changeMenuModule('listado-roles')">
          Cancelar
        </button>
      </div>
    </div>
    <div class="col-md-2" *ngIf="!isEdit">
      <div style="text-align: right;">
        <button
          [disabled]="roleForm.invalid"
          (click)="createRole()"
          class="btn round-button">
          Guardar
        </button>
      </div>
    </div>
    <div class="col-md-2" *ngIf="isEdit">
      <div style="text-align: right;">
        <button
          [disabled]="roleForm.invalid"
          (click)="updateRole()"
          class="btn round-button">
          Actualizar
        </button>
      </div>
    </div>
  </div>
  </form>
</div>
